import React from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { ContactInfoWrapper } from "./styles";

const ContactInfo = (props) => {
	const { data } = props;
	return (
		<ContactInfoWrapper>
			<div className="smoothWhiteTwistedBackground">
				<div className="firstSection">
					<div className="communicationChannelsContainer">
						{data.communicationChannels.map((communicationChannel, index) => {
							return (
								<div className="communicationChannel" key={index}>
									<CloudinaryImage
										url={communicationChannel.iconUrl.image}
										lazyload
										fetchFormat={"svg"}
									></CloudinaryImage>
									<span className="title boldFont">
										{communicationChannel.title}
									</span>
									{communicationChannel.forProspectiveStudent && (
										<span className="text">
											<strong>PROSPECTIVE STUDENTS &nbsp;</strong>
											<a
												href={
													"mailto:" + communicationChannel.forProspectiveStudent
												}
											>
												{communicationChannel.forProspectiveStudent}
											</a>
										</span>
									)}
									{communicationChannel.forEnrolledStudent && (
										<span className="text">
											<strong>ENROLLED STUDENTS &nbsp;</strong>
											<a
												href={
													"mailto:" + communicationChannel.forEnrolledStudent
												}
											>
												{communicationChannel.forEnrolledStudent}
											</a>
										</span>
									)}
									{communicationChannel.forMentor && (
										<span className="text">
											<strong>MENTORS &nbsp;</strong>
											<a href={"mailto:" + communicationChannel.forMentor}>
												{communicationChannel.forMentor}
											</a>
										</span>
									)}
									{communicationChannel.forCandidate && (
										<span className="text">
											<strong>CANDIDATES &nbsp;</strong>
											<a href={"mailto:" + communicationChannel.forCandidate}>
												{communicationChannel.forCandidate}
											</a>
										</span>
									)}
									<div
										className="text"
										dangerouslySetInnerHTML={{
											__html: communicationChannel.description.content,
										}}
									></div>
								</div>
							);
						})}
					</div>
					<div className="springboardFolks">
						{data.springboardFolks.map((folk, index) => {
							return (
								<div key={index}>
									<CloudinaryImage
										lazyload
										url={folk.link.image}
									></CloudinaryImage>
								</div>
							);
						})}
					</div>
				</div>

				<div className="socialLinksContainer">
					<div className="socialLinks">
						<a
							className="socialLink no-text-decoration"
							href={data.socialLinks.facebookUrl}
						>
							<span className="socialImage">
								<CloudinaryImage
									lazyload
									url={
										"https://res.cloudinary.com/springboard-images/image/upload/v1592727141/homepage-assets/social/social-facebook@2x.png"
									}
									alt=""
								></CloudinaryImage>
							</span>
							<span className="heavyWeight">Like us on Facebook</span>
						</a>
						<a
							className="socialLink no-text-decoration"
							href={data.socialLinks.twitterUrl}
						>
							<span className="socialImage">
								<CloudinaryImage
									lazyload
									url={
										"https://res.cloudinary.com/springboard-images/image/upload/v1592727141/homepage-assets/social/social-twitter@2x.png"
									}
									imageClass="socialImage"
									alt=""
								></CloudinaryImage>
							</span>
							<span className="heavyWeight">Tweet us on Twitter</span>
						</a>
						<a
							className="socialLink no-text-decoration"
							href={data.socialLinks.mediumUrl}
						>
							<span className="socialImage">
								<CloudinaryImage
									lazyload
									url={
										"https://res.cloudinary.com/springboard-images/image/upload/v1592727141/homepage-assets/social/social-medium@2x.png"
									}
									imageClass="socialImage"
									alt=""
								></CloudinaryImage>
							</span>
							<span className="heavyWeight">Read our stories on Medium</span>
						</a>
					</div>
					<div className="owlContainer">
						<div className="messageBubble boldFont">Let’s get s-owl-cial!</div>
						<CloudinaryImage
							lazyload
							url={
								"https://res.cloudinary.com/springboard-images/image/upload/v1592727141/homepage-assets/contact-us/owl-social.png"
							}
						></CloudinaryImage>
					</div>
				</div>
			</div>
		</ContactInfoWrapper>
	);
};

ContactInfo.propTypes = {
	data: PropTypes.object.isRequired,
};

ContactInfo.defaultProps = {
	data: {},
};

export default ContactInfo;
